import { requireNativeViewManager } from 'expo-modules-core';
import * as React from 'react';

import { ExpoWifiRttViewProps } from './ExpoWifiRtt.types';

const NativeView: React.ComponentType<ExpoWifiRttViewProps> =
  requireNativeViewManager('ExpoWifiRtt');

export default function ExpoWifiRttView(props: ExpoWifiRttViewProps) {
  return <NativeView {...props} />;
}
